<template>
  <el-dialog width="25%"
             :show-close="false"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :visible.sync="dialogFormVisible"
             >
    <div class="success-div">
      <span class="success-child"></span>
    </div>
    <h1>{{$t('setting.confirm.title')}}</h1>
    <p>{{$t('setting.confirm.p1')}}</p>
    <p>{{$t('setting.confirm.p2')}}</p>
    <div slot="footer"
         class="dialog-footer">
      <el-button type="primary"
                 class="submit-button"
                 @click="submitForm('form')"
                 test_id="setting_back_login">{{$t('setting.confirm.back')}}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import store from '@/store'
import SecurityService from '@/js/util/SecurityService.js'
export default {
  data () {
    return {
      dialogFormVisible: false,
      formLabelWidth: '120px',
      labelPosition: 'top'
    }
  },
  methods: {
    submitForm (formName) {
      this.dialogFormVisible = false
      // this.$router.push('/login');
      const oAuth = new SecurityService()
      oAuth.signOut()
      store.commit('setUser', null)
    }
  }
}
</script>
<style lang="scss" scoped>
h1,
p {
  text-align: center;
}
.submit-button {
  width: 100%;
  height: 100%;
  margin: auto;
  line-height: 20px;
  color: black !important;
  border: 1px solid rgba(255, 255, 255, 0);
}
.dialog-footer {
  width: 50%;
  height: 3rem;
  margin: 1rem auto 3rem auto;
}
.success-div {
  margin: auto;
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  background-color: rgba(254, 192, 0, 1);
}
.success-child {
  position: relative;
  width: 5rem;
  height: 5rem;
}

.success-child::after {
  position: absolute;
  top: 0.7rem;
  left: 1.5rem;
  width: 1.5rem;
  height: 2.5rem;
  border-style: solid;
  border-color: white;
  border-width: 0 5px 5px 0;
  transform: rotateZ(45deg);
  content: '';
}
</style>
